export default "__VITE_ASSET__BWTCEGi$__"